import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const CircleIconContainer = styled.div`
  height: ${props => pxToRem(props.size)};
  width: ${props => pxToRem(props.size)};
  border-radius: 50%;
  background-color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
`;
